import React from 'react';
import DashboardElearningComponent from '../Component/DashboardElearningComponent';

export default function DashboardElearningContainer() {
  return <DashboardElearningComponent />;
}
